<template>
  <div class="">
    <NowYear v-if="isNowYear" />
    <OldYear v-else />
  </div>
</template>

<script>
import NowYear from './BeefCattleSmallList22023'
import OldYear from './BeefCattleSmallList2'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  components: {
    NowYear,
    OldYear,
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      isNowYear: (state) => state.online.year == '2024',
    }),
  },
  methods: {},
}
</script>
<style lang="scss" scoped></style>
